import { earlierWorkshopsSchema } from '@mio/shared';
import { useInfiniteQuery } from '@tanstack/react-query';

import { apiRequest } from '@/shared/api/client';

export function useEarlierWorkshops() {
  return useInfiniteQuery({
    queryKey: ['workshop', 'earlier'],
    initialPageParam: null as string | null,
    queryFn: ({ pageParam, signal }) =>
      apiRequest(
        `/workshop/earlier${pageParam ? `?after=${encodeURIComponent(pageParam)}` : ''}`,
        earlierWorkshopsSchema,
        { signal },
      ),
    getNextPageParam: (page) => page.nextCursor,
  });
}
